<template>
  <div
    class="history-dialog absolute_center"
    :class="{
      _boxBg_small: styleType == 'typeDark',
      _boxBg_small_green: styleType == 'typeGreen',
      _boxBg_small_blue: styleType == 'typeBlue',
      _boxBg_small_Strong: styleType == 'typeStrong'
    }"
  >
    <div class="_closeBox" @click="close"></div>
    <div class="_boxTitle">
      <i></i>
      历史查询
    </div>
    <div class="dialog_form">
      <div class="public-form">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="起止时间：" prop="timeArr">
            <!-- <el-date-picker v-model="timeArr" :disabledDate="pickerOptions" type="datetimerange" range-separator="-" start-placeholder="开始日期"
              end-placeholder="结束日期"  @change="dateChange">
            </el-date-picker>-->
            <DatePicker
              :date="date"
              @dateChange="dateChange"
              :initWidth="'400px'"
              :topPx="'50px'"
              :formatType="'YYYY-MM-DD HH:mm:ss'"
              dateType="timerange"
              :currentDateList="timeArr"
              :needInitTime="false"
            />
          </el-form-item>
          <el-form-item>
            <a class="self_btn" @click="checkFun">查询</a>
          </el-form-item>
        </el-form>
        <div class="taps">
          <a class="self_btn" :class="paramsData.type == 1 ? '_active' : ''" @click="changeDataType(1)">PM2.5</a>
          <a class="self_btn" :class="paramsData.type == 2 ? '_active' : ''" @click="changeDataType(2)">PM10</a>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="dialog_name">{{echart_Title}}</div>
      <div class="content">
        <div class="chart" ref="chart10Rf"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import getOpt from './chartOpt.js'
import { unwarp, formatDateTime } from '@/utils/tools.js'
import { DatePicker } from '@/modules/commonDatePicker/index.js'
import moment from 'moment'
export default {
  name: 'history-dialog-pm10',
  title: '历史查询',
  props: ['globalInstance'],
  components: { DatePicker },
  setup(props) {
    const globalInstance = props.globalInstance
    return { globalInstance }
  },
  data() {
    return {
      date: new Date(),
      styleType: '',
      customerId: this.globalInstance.$store.state.customerId,
      chart25: null,
      chart10: null,
      dataObj: {
        xData: [],
        yData: []
      },
      unit: 2, //	1:最近24小时，2：最近30天，
      //vType:1//1：PM2.5，2：PM10
      timeArr: [formatDateTime(new Date().getTime() - 7 * 24 * 60 * 60 * 1000) + ' 00:00', formatDateTime(new Date().getTime()) + ' 00:00'],
      echart_Title: '',
      paramsData: {
        customerId: this.globalInstance.$store.state.customerId,
        type: 2, //1：PM2.5，2：PM10
        startTime: formatDateTime(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
        endTime: formatDateTime(new Date().getTime())
      },
      endTimeStr: moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss'),
      startTimeStr: moment(new Date().getTime() - 1000 * 60 * 60 * 96).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  created() {
    this.styleType = this.globalInstance.$store.state.styleType
    if(this.globalInstance.$store.state.currentRealtimeENVType == "pm25") {
      this.paramsData.type = 1;
      this.echart_Title = "PM2.5（μg/m³）"
    } else if(this.globalInstance.$store.state.currentRealtimeENVType == "pm10") {
      this.paramsData.type = 2
      this.echart_Title = "PM10（μg/m³）"
    }
  },
  mounted() {
    this.getChart()
  },
  computed: {
    curStyleTypeVal() {
      return this.globalInstance.$store.state.styleType
    }
  },
  beforeUnmount() {
    if (this.chart25 || this.chart10) {
      this.chart10 = this.chart10.dispose()
      this.chart25 = null
      this.chart10 = null
    }
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal
      },
      deep: true
    }
  },
  methods: {
    testChange(time) {
      console.log(time, '接收的timeArr')
    },
    pickerOptions(time) {
      if (this.customerId == 1414) {
        return time.getTime() > new Date().getTime() || new Date('2021-07-01 00:00:00').getTime() > time.getTime()
      } else {
        return time.getTime() > new Date().getTime()
      }
    },
    dateChange(e) {
      this.timeArr = e
    },
    async getData() {
      let findHistoryValue = CONFIG.requestName + this.globalInstance.$apiOpt.findHistoryValue;
      let that = this;
      let data = await this.globalInstance.$apiUtils.get(findHistoryValue, this.paramsData)
      let dataObj = {
        xData: [],
        yData1: [],
        yData2: []
      }
      data.forEach((x, index) => {
        dataObj.xData.push(x.dayTime)
        dataObj.yData1.push(x.avgValue || 0)
        dataObj.yData2.push(x.skAvgValue || 0)
      })
      if(this.paramsData.type == 1) {
        dataObj.markData = 35
      } else if(this.paramsData.type == 2) {
        dataObj.markData = 50
      }
      return dataObj
    },
    async getChart() {
      let dataObj1 = await this.getData()
      let chart10Rf = this.$refs.chart10Rf
      this.chart10 = echarts.init(chart10Rf)
      unwarp(this.chart10).setOption(getOpt(dataObj1))
    },
    changeDataType(type) {
      this.paramsData.type = type;
      if(type == 1) {
        this.echart_Title = "PM2.5（μg/m³）"
      } else if(type == 2) {
        this.echart_Title = "PM10（μg/m³）"
      }
      this.getChart()
    },
    checkFun() {
      if (this.timeArr.length) {
        this.paramsData.startTime = this.timeArr[0]
        this.paramsData.endTime = this.timeArr[1]
      } else {
        this.paramsData.startTime = ''
        this.paramsData.endTime = ''
      }
      if (this.paramsData.endTime) {
        this.getChart()
      }
    },
    close() {
      let that = this._.appContext.app
      this.$popup.close(that)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.history-dialog {
  width: 882px !important;
  height: 732px !important;
  padding: 38px 36px;
  position: relative;
  .dialog_form {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*margin: 0px 0 40px;*/
    width: fit-content;
    .public-form {
      .el-form-item {
        margin-top: 0;
        .el-form-item__content {
          button {
            height: initial;
          }
        }
      }
    }
  }
  & > .item {
    margin: 10px 0;
    .dialog_name {
      font-size: 28px;
      position: relative;
      margin-left: 20px;
      &:before {
        content: '';
        position: absolute;
        top: 50%;
        margin-top: -15px;
        left: -20px;
        width: 4px;
        height: 27px;
        background: rgba(70, 165, 231, 1);
      }
    }
  }
}

._boxBg_small_blue {
  width: 1282px !important;
  height: 802px !important;
}

.chart {
  margin-top: 20px;
  width: 100%;
  height: 455px;
}
</style>
<style type="text/css">
._boxBg .el-input__inner {
  background: #071127;
  color: #00adff;
}
._boxBg .el-date-editor .el-range-input {
  font-size: 18px !important;
  color: #00adff;
}
._boxBg .el-range-editor.el-input__inner {
  width: 450px !important;
}

._boxBg_green .el-input__inner {
  background: #071127;
  color: rgb(153, 245, 255) !important;
}
._boxBg_green .el-date-editor .el-range-input {
  font-size: 18px !important;
  color: rgb(153, 245, 255) !important;
}
._boxBg_green .el-range-editor.el-input__inner {
  width: 450px !important;
}
._boxBg_green .el-form-item__label {
  color: rgb(153, 245, 255) !important;
}
.history-dialog .el-date-editor {
  width: 460px !important;
}
.taps {
  position: absolute;
  right: 0px;
  width: 260px;
  height: 40px;
  top: 110px;
  z-index: 333;
}
</style>
